/**
 * @generated SignedSource<<b3b37a376c8e9a7f7ebbc22a019afd2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetLessonTypeOptions_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityShowLessonPrices_facility">;
  readonly " $fragmentType": "useGetLessonTypeOptions_facility";
};
export type useGetLessonTypeOptions_facility$key = {
  readonly " $data"?: useGetLessonTypeOptions_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetLessonTypeOptions_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityShowLessonPrices_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "9dc84ce3e15329e158c77fb423d77420";

export default node;
